// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import cssProp from "@store/Framework/Common/Utilities/cssProp";
import { pxToRem } from "@store/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

export const countBubblePositionStyles = (position: (string | null)[] | undefined) => {
    return css`
        ${cssProp("top", position?.[0])}
        ${cssProp("right", position?.[1])}
        ${cssProp("bottom", position?.[2])}
        ${cssProp("left", position?.[3])}
    `;
};

export const countBubbleStyles = (position?: (string | null)[], bgColor?: string) => {
    return css`
        ${countBubblePositionStyles(position)}
        position: absolute;
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: center;
        font-size: ${pxToRem(10)};
        width: ${pxToRem(19)};
        height: ${pxToRem(19)};
        padding-top: ${pxToRem(3)};
        font-weight: ${x => x.theme.design.typography.weight.bold};
        border: 1px solid ${getColor("header")};
        background-color: ${getColor(bgColor || "header.accent")};
        color: ${getColor("header.accentContrast")};
        border-radius: 50%;
        letter-spacing: ${pxToRem(-0.5)};
    `;
};
